export default "__VITE_ASSET__CS_O3awq__"